/** The element that scrolls `element` into view: the nearest ancestor its content overflows, else the page */
export function scrollContainerOf(element: HTMLElement): HTMLElement {
  let ancestor = element.parentElement;
  while (ancestor && ancestor !== document.body) {
    // An overflow container that grows with its content (Balsa's mat-sidenav-content) leaves the scrolling to the page
    if (getComputedStyle(ancestor).overflowY !== 'visible' && ancestor.scrollHeight > ancestor.clientHeight) {
      return ancestor;
    }

    ancestor = ancestor.parentElement;
  }

  return document.documentElement;
}
